<template>
    <div class="settings-container" v-if="props.data">
        <div class="section-header section-header-2">
          <h3>View performance summaries</h3>
          <div v-if="props.data.viewPerformanceSummaries">
            <el-select v-if="props.canEdit"
              v-model="props.data.viewPerformanceSummaries.permission"
              default-first-option
            >
              <el-option v-for="item in props.data.viewPerformanceSummaries.permissionOption" :key="item.type" :label="item.name" :value="item.type" />
            </el-select>
            <span v-else>{{ switchParentText(props.data.viewPerformanceSummaries.permission) }}</span>
          </div>
        </div>
    </div>
  </template>
  
  <script setup>
  import { reactive } from 'vue';
  import { ElSelect, ElOption } from 'element-plus';
  import { useTeamFunction } from './teamFunction';

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({})
    },
    isOwner: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  });

  const { switchItem,switchText,switchParentText } = useTeamFunction();
  //+++++++++++++++++++++++++++++++++++
  </script>
  
  <style scoped>
  
  </style>